import { HttpResponse } from "msw";
import { PrintResult } from "../hooks/react-query/usePrint";

const mockReport = {
  default: {
    id: crypto.randomUUID(),
    state: "Processed",
    url: "https://example.com/report.pdf",
    type: "CarrierBillOfLading",
  },
} as const satisfies Record<string, PrintResult>;

export const getMockReport = () =>
  HttpResponse.json(mockReport.default, {
    headers: {
      "Content-Type": "applcation/pdf",
    },
  });
